import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./components/home/Home";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import WhatsAppButton from "./components/whatsapp/WhatsAppButton";
import GoTop from "./components/goTop/GoTop";
import Product from "./components/products/Product";
import ProductDetails from "./components/products/ProductDetails";
import Checkout from "./components/products/Checkout";
import PaymentSuccess from "./components/products/PaymentSuccess";
import Cart from "./components/cart/Cart";
import Wishlist from "./components/wishlist/Wishlist";
import Review from "./components/review/Review";
import ComboProduct from "./components/products/ComboProduct";

import Profile from "./components/profile/Profile";
// import BlogDetails from "./components/blog/BlogDetails";
import OrderTraking from "./components/order/OrderTraking";
import Login from "./components/auth/Login";
import Signup from "./components/auth/Signup";
import ForgetPassword from "./components/auth/ForgetPassword";
import Otp from "./components/auth/Otp";
import ChangePassword from "./components/auth/ChangePassword";


import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Toaster } from "react-hot-toast";
import PublicRoute from "./hoc/PublicRoute";
import PrivateRoute from "./hoc/PrivateRoute";
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from "./components/scrolltop/ScrollTop";
import { ReturnPolicy } from "./components/returnpolicy/ReturnPolicy";


function Layout({ children }) {
  const location = useLocation();

  // hide layout on comingsoon page
  const hideLayout = location.pathname.startsWith("/comingsoon/comingsoon");

  return (
    <>
      {!hideLayout && <Navbar />}
      
      {children}
      {!hideLayout && <Footer />}
      {!hideLayout && <GoTop />}
      {!hideLayout && <WhatsAppButton />}
      {/* {!hideLayout && <OfferPopup />} */}
    </>
  );
}

function App() {
  return (
    
    <BrowserRouter>
    <ScrollToTop/>
     <Toaster position="top-right" reverseOrder={false} />
      <Layout>
        <Routes>
          
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/products/product" element={<Product />} />
          <Route path="/products/:catid/:catname" element={<Product />} />
          <Route path="/products/:id" element={<ProductDetails />} />
          <Route path="/products/paymentsuccess" element={<PaymentSuccess />} />
          <Route path="/cart/cart" element={<Cart />} />
          <Route path="/review/review" element={<Review />} />
          <Route path="/return-policy" element={<ReturnPolicy/>} />
          
          
          <Route path="/auth/changepassword" element={<ChangePassword />} />
          
          <Route path="/combo/:id" element={<ComboProduct />} />
          <Route path="/thank-you" element={<PaymentSuccess />} />

          {/* Private Routes */}
          <Route element={<PrivateRoute />}>
            <Route path="/profile/profile" element={<Profile />} />
            <Route path="/order/ordertracking" element={<OrderTraking />} />
            <Route path="/wishlist/wishlist" element={<Wishlist />} />
            <Route path="/products/checkout" element={<Checkout />} />
          </Route>
          <Route element={<PublicRoute />}>
            <Route path="/auth/login" element={<Login />} />
            <Route path="/auth/signup" element={<Signup />} />
            <Route path="/auth/forgotpassword" element={<ForgetPassword />} />
            <Route path="/auth/otp" element={<Otp />} />
          </Route>

          
        </Routes>
      </Layout>
    </BrowserRouter>
    
  );
}

export default App;
